export const C_SETTING_KEY_CERTTUS_BANCO_DADOS = "certtusBancoDados"

export function companyBackofficeIntegradaDeSettings(aSettings) {
  if (!Array.isArray(aSettings)) {
    return false
  }

  const oSetting = aSettings.find((oItem) => oItem.key === C_SETTING_KEY_CERTTUS_BANCO_DADOS)
  if (oSetting == null || typeof oSetting.value !== "string") {
    return false
  }

  const cValor = oSetting.value.trim()
  if (!cValor || cValor.length > 60) {
    return false
  }

  return /^[A-Za-z0-9]+$/.test(cValor)
}

export default companyBackofficeIntegradaDeSettings
